import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import styled from "styled-components";

export const SectorContainer = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
  padding-bottom: 40px;
  margin-top: -40px;
`;

export const SectorImage = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
  background-color: #edf1fc;
  opacity: 0.4;
  z-index: -1;
  position: absolute;
  top: 0;
  left: 50%;
  transform: translateX(-50%);
`;

export const SectorIntroTitle = styled.h3`
  font-size: 12px;
  letter-spacing: 2px;
  color: #3393f0;
  text-align: center;
  margin-bottom: 20px;
  margin-top: 20px;
  position: relative;
`;

export const SectorTitle = styled.h1`
  color: #17224d;
  text-align: center;
  position: relative;
  z-index: 4;
`;

export const SectorCardContainer = styled.div`
  padding: 20px;
  width: 90%;
  margin: 0 auto;
  max-width: 1400px;
  margin-top: 40px;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 10px;

  @media (max-width: 1300px) {
    flex-direction: column;
    align-items: center;
  }
`;

export const SectorCardIcon = styled(FontAwesomeIcon)`
  font-size: 40px;
  margin-bottom: 15px;
  background-color: #edf1fc;
  padding: 20px;
  border-radius: 50%;
  color: #3393f0;
`;

export const SectorCardTitle = styled.h2`
  margin: 10px 0;
  color: #17224d;
`;

export const SectorCardText = styled.p`
  margin: 10px 0;
  font-size: 14px;
  color: #17224d;
  flex-grow: 1;
`;

export const SectorCard = styled.div`
  background-color: white;
  min-width: 22%;
  max-width: 22%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  padding: 20px 40px 20px 40px;
  text-align: center;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.3);
  border-radius: 24px;
  transition: transform 1.5s ease, background-color 0.3s ease, color 0.3s ease;

  @media (max-width: 1300px) {
    min-width: 100%;
  }

  &:hover {
    transform: translateY(-5%);
    background-color: #3393f0;
    color: white;
  }

  &:hover ${SectorCardTitle}, &:hover ${SectorCardText} {
    color: white;
  }
`;
